"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["className", "reserveHintSpace"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingBox, Stack, useBoxStyles } from '@autoguru/overdrive';
import { HintText } from '@autoguru/overdrive/dist/components/private/InputBase/HintText';
import clsx from 'clsx';
import * as styles from './InputLoading.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InputLoading = _ref => {
  let {
      className,
      reserveHintSpace
    } = _ref,
    loadingBoxProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Stack, {
    width: "full",
    space: "none",
    children: [/*#__PURE__*/_jsx(LoadingBox, _objectSpread(_objectSpread({}, loadingBoxProps), {}, {
      className: clsx(className, styles.inputLoading, useBoxStyles({
        width: 'full'
      }))
    })), /*#__PURE__*/_jsx(LoadingBox, _objectSpread(_objectSpread({}, loadingBoxProps), {}, {
      className: clsx(className, styles.inputLoading, useBoxStyles({
        width: 'full'
      }))
    })), reserveHintSpace ? /*#__PURE__*/_jsx(HintText, {
      reserveHintSpace: reserveHintSpace,
      hintText: void 0
    }) : null]
  });
};